const config = {
  idle: 'hmUI.show_level.ONLY_AOD',
  normal: 'hmUI.show_level.ONLY_NORMAL'
}

export default config
